import {
	Component,
	OnInit,
	Input,
	OnChanges,
	AfterViewInit,
	ChangeDetectorRef,
	Output,
	NgZone,
	EventEmitter
} from '@angular/core';
import { XlsFormCalculateModelInterface } from '../../../models';
import { FormGroup, FormBuilder, FormArray, Validators, FormControl } from '@angular/forms';

declare var $: any;

@Component({
	selector: 'app-calculate-instance',
	templateUrl: './calculate.instance.html'
})
export class CalculateInstanceComponent implements OnInit, AfterViewInit {
	@Input() model: XlsFormCalculateModelInterface;
	@Input() modelForm: FormGroup;
	@Input() selectComponents: any;
	@Input() isEdit: boolean;
	@Input() error: boolean;

	@Output() onEdit = new EventEmitter();
	@Output() onClose = new EventEmitter();
	@Output() onSubmit = new EventEmitter();

	@Output() onArray = new EventEmitter();

	constructor(private zone: NgZone, private ref: ChangeDetectorRef) {}

	calMethod(cal) {
		var $txt = $('#txtId');
		var caretPos = $txt[0].selectionStart;
		var textAreaTxt = $txt.val();
		var txtToAdd = `${cal}`;
		$txt.val(textAreaTxt.substring(0, caretPos) + txtToAdd + textAreaTxt.substring(caretPos));
	}

	fedMethod(fied) {
		let field = fied.target.value;
		var $txt = $('#txtId');
		var caretPos = $txt[0].selectionStart;
		var textAreaTxt = $txt.val();
		var txtToAdd = '${' + field + '}';
		$txt.val(textAreaTxt.substring(0, caretPos) + txtToAdd + textAreaTxt.substring(caretPos));
	}

	doSomething(evt) {
		// console.log('suppose to update view',evt)
		// this.zone.run(() => {
		if (evt) {
			let rel = evt.replace(/ /g, '_').toLowerCase();
			this.model.name = rel.replace(/[^\w]/gi, '');
		}
		// })
	}
	continue() {
		this.isEdit == true ? this.edit() : this.save();
	}
	save() {
		this.modelForm.value.id = this.model.id;
		this.modelForm.value.type = this.model.type;
		this.modelForm.value.inputStyle = this.model.inputStyle;
		this.modelForm.value.control = this.model.control;
		this.modelForm.value.parentModel = this.model.parentModel;
		let newModel: XlsFormCalculateModelInterface;

		this.onSubmit.emit(Object.assign({}, newModel, this.modelForm.value));
	}

	edit() {
		let newModel = Object.assign({}, this.model);
		newModel.constraintGroup = this.modelForm.value.constraintGroup;
		newModel.relevantGroup = this.modelForm.value.relevantGroup;
		this.onEdit.emit(newModel);
	}

	ngOnInit() {
		// console.log(this.modelComponent)
	}
	ngAfterViewInit() {}
}
